import React from 'react'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../../../_metronic/helpers'

type Props = {
  title: number
  description: string
  url: string
  icon: string
  color: string
}

const DashboardButtons: React.FC<Props> = ({title, description, icon, color, url}: any) => {
  return (
    <>
      <div className='col-6 d-flex justify-content-center'>
        <Link
          to={url}
          className='card card-stretched bg-body hoverable mb-xl-8 w-100 h-100'
        >
          <div className='card-body'>
            <span className='svg-icon svg-icon-body svg-icon-3x ms-n1'>
              <KTSVG className={color && `svg-icon-${color}`} path={icon} />
            </span>

            <div className='fw-bold fs-1 mb-2 mt-5 text-body'>{title}</div>
            <div className='fw-semibold text-body'>{description}</div>
          </div>
        </Link>
      </div>
    </>
  )
}

export {DashboardButtons}
